/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useNavigationCssClasses } from '../../hooks';
import { NavLinkButton } from '../NavLinkButton/NavLinkButton';
import './NavSubItem.scss';
export const NavSubItem = ({ list, collapsed = false, }) => {
    const { navSubItemCss } = useNavigationCssClasses({ collapsed });
    return (React.createElement("ul", { className: navSubItemCss }, list === null || list === void 0 ? void 0 : list.map(({ linkText, linkUrl, onClick, disabled, exact, overrideActive }) => {
        const isActive = useRouteMatch({ path: linkUrl, exact });
        const { navSubItemBulletCss } = useNavigationCssClasses({
            disabled,
            active: overrideActive || isActive,
        });
        return (React.createElement("li", { key: `${linkText}_${linkUrl}`, className: navSubItemBulletCss },
            React.createElement(NavLinkButton, { onClick: onClick, path: linkUrl, disabled: disabled, collapsed: collapsed }, linkText)));
    })));
};
//# sourceMappingURL=NavSubItem.js.map